/**
 * @generated SignedSource<<84a6472e8646d922a2803b75fd882237>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapMenuItems_collection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapFavoriteSubmenu_collection">;
  readonly " $fragmentType": "RoadmapMenuItems_collection";
};
export type RoadmapMenuItems_collection$key = {
  readonly " $data"?: RoadmapMenuItems_collection$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapMenuItems_collection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RoadmapMenuItems_collection",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RoadmapFavoriteSubmenu_collection"
    }
  ],
  "type": "JiraProductDiscoveryCollection"
};

(node as any).hash = "4a5b7b0113e154dbc44ec377ce596954";

export default node;
